<template>
  <div class="ba-wrap">
    <div class="ba-topbar">
      <button class="ba-back-btn" @click="router.push({ name: 'BookingHome' })">
        ← 返回預約首頁
      </button>
    </div>

    <h1 class="ba-title">📢 平台公告</h1>
    <p class="ba-subtitle">來自平台的最新公告與說明</p>

    <div v-if="loading" class="ba-state">載入中…</div>
    <div v-else-if="announcements.length === 0" class="ba-state">目前沒有公告</div>

    <div v-else class="ba-list">
      <div
        v-for="a in visibleList"
        :key="a.id"
        class="ba-item"
        @click="router.push({ name: 'BookingAnnouncementDetail', params: { id: a.id } })"
      >
        <span class="ba-badge">公告</span>
        <span class="ba-name">{{ a.title }}</span>
        <span class="ba-date">{{ formatDate(a.created_at) }}</span>
        <span class="ba-arrow">→</span>
      </div>
      <!-- 更多公告按鈕 -->
      <div v-if="hasMore && !showAll" class="ba-more" @click="showAll = true">
        更多公告 ↓
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

const router = useRouter()
const announcements = ref([])
const loading = ref(false)
const showAll = ref(false)

const PAGE_SIZE = 5
const visibleList = computed(() =>
  showAll.value ? announcements.value : announcements.value.slice(0, PAGE_SIZE)
)
const hasMore = computed(() => announcements.value.length > PAGE_SIZE)

function formatDate(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('zh-TW', {
    timeZone: 'Asia/Taipei',
    year: 'numeric', month: '2-digit', day: '2-digit'
  })
}

onMounted(async () => {
  loading.value = true
  try {
    const { data } = await axios.get('/api/booking/announcements/active?frontend=1')
    announcements.value = data.announcements || []
  } catch (_) { /* 靜默忽略 */ } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.ba-wrap {
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 16px 64px;
}

.ba-topbar {
  margin-bottom: 24px;
}

.ba-back-btn {
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  color: #8b6f5c;
  font-weight: 600;
  padding: 0;
  transition: opacity 0.15s;
}
.ba-back-btn:hover { opacity: 0.7; }

.ba-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 6px;
}

.ba-subtitle {
  color: #7f8c8d;
  font-size: 0.95rem;
  margin-bottom: 28px;
}

.ba-state {
  color: #aaa;
  font-size: 0.95rem;
  padding: 32px 0;
  text-align: center;
}

.ba-list {
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.ba-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.15s;
}
.ba-item:last-child { border-bottom: none; }
.ba-item:hover { background: #fafafa; }

.ba-badge {
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  background: #f59e0b;
  color: #fff;
  letter-spacing: 0.03em;
}

.ba-name {
  flex: 1;
  font-size: 0.93rem;
  font-weight: 600;
  color: #2c3e50;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ba-date {
  flex-shrink: 0;
  font-size: 0.8rem;
  color: #aaa;
}

.ba-arrow {
  flex-shrink: 0;
  font-size: 0.8rem;
  color: #bbb;
}

.ba-more {
  padding: 13px 18px;
  text-align: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: #8b6f5c;
  cursor: pointer;
  transition: background 0.15s;
  border-top: 1px solid #f0f0f0;
}
.ba-more:hover { background: #fdf8f5; }
</style>
